import { render, staticRenderFns } from "./SelectedRows.vue?vue&type=template&id=de4ab7e2&scoped=true&"
import script from "./SelectedRows.vue?vue&type=script&lang=ts&"
export * from "./SelectedRows.vue?vue&type=script&lang=ts&"
import style0 from "./SelectedRows.vue?vue&type=style&index=0&id=de4ab7e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de4ab7e2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
